import { Link } from "react-router-dom";
import SEO from "@/components/SEO";

export default function NotFound() {
  return (
    <>
      <SEO
        title="Page not found — LightningFlow"
        description="The LightningFlow page you requested could not be found."
        canonicalPath="/"
        noIndex
      />
      <section className="min-h-[60vh] flex items-center" data-testid="not-found-page">
        <div className="lf-container py-24 text-center">
          <div className="lf-eyebrow inline-flex">404 · Page not found</div>
          <h1 className="mt-6 font-display text-5xl md:text-6xl font-black tracking-tight">
            We couldn’t find that page.
          </h1>
          <p className="mt-5 text-ink-500 max-w-xl mx-auto">
            The page may have moved. Return home or explore the LightningFlow platform.
          </p>
          <div className="mt-8 flex flex-wrap justify-center gap-3">
            <Link to="/" className="lf-btn-primary" data-testid="not-found-home-link">
              Back to Home
            </Link>
            <Link to="/support" className="lf-btn-secondary">
              Contact support
            </Link>
          </div>
        </div>
      </section>
    </>
  );
}
